<template>
  <div class="complectation-element-manage flex flex-col">
    <div class="title flex justify-between items-center">
      <span>{{$t('client.pages.title')}}</span>
      <button @click="$store.dispatch('clientMain/setManageElement', null)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="body flex-1 overflow-x-hidden">
      <div class="pages-list">
        <div
          class="page-item"
          v-for="page in pages"
          :key="`page-${page.page_id}`"
        >
          <button @click="showPage = page">{{ page.title }}</button>
        </div>
      </div>
    </div>
    <ClientModal
      v-if="showPage"
      @close-modal="showPage = null"
    >
      <template #header>
        <span class="show-page-title">{{ showPage.title }}</span>
      </template>
      <div
        class="show-page-content h-full overflow-x-hidden pb-12"
        v-html="showPage.content"
      ></div>
    </ClientModal>
  </div>
</template>
<script>
import ClientModal from "../../shared/components/ClientModal.vue";
export default {
  name: "Pages",
  components: { ClientModal },
  data() {
    return {
      showPage: null,
    };
  },
  created() {
    this.$store.dispatch("clientPages/fetch");
  },
  computed: {
    pages() {
      return this.$store.state.clientPages.pages;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 1000px) {
  .pages-list {
    padding: 0 15px;
  }
  .pages-list .page-item {
    padding: 10px 0;
  }
  .pages-list .page-item button {
    font-size: 1rem;
    line-height: 1.1;
    text-align: left;
  }
}
</style>

